import { ADD_UNIT_TO_STATE, ADD_LESSON_TO_STATE, SET_UNIT_ACTIVE, EDIT_LESSON_START_DATE } from './actionTypes';
import axios from 'config/axios';

import Notification from 'components/UI/Notification';
import { showNotification, showServerNotification } from './uiActions';

export const addUnitToStore = (unit) => async (dispatch) => {
    const currentLessonObj =
        unit.LessonGroups && unit.LessonGroups.find((group) => +group.UnitLessonGroup.isCurrent === 1);
    const currentLesson = (currentLessonObj && currentLessonObj.groupId) || unit.LessonGroups[0].groupId;
    unit.UnitLessonGroup = [];
    unit.LessonGroups = unit.LessonGroups.map((group) => {
        unit.UnitLessonGroup.push(group.UnitLessonGroup);
        delete group.UnitLessonGroup;
        dispatch({
            type: ADD_LESSON_TO_STATE,
            payload: { ...group, unitId: unit.unitId },
        });
        return group.groupId;
    });
    dispatch({
        type: ADD_UNIT_TO_STATE,
        payload: { ...unit, currentLesson },
    });
};

export const setUnitActive = (unitId, classId) => async (dispatch) => {
    try {
        const successUnitId = await axios.post(`/api_v2/curriculum/set-active`, { unitId, classId });
        if (successUnitId) {
            dispatch({
                type: SET_UNIT_ACTIVE,
                payload: { unitId },
            });
            dispatch(showServerNotification('Unit was successfully assigned to the class', [], 5000, null));
        } else {
            dispatch(showNotification(Notification.DANGER, 'Failed to assign unit to class'));
        }
    } catch (err) {
        dispatch(showNotification(Notification.DANGER, 'Failed to assign unit to class'));
    }
};

export const setLessonStartDate = (unitId, groupId, startDate) => async (dispatch) => {
    try {
        dispatch({ type: EDIT_LESSON_START_DATE, payload: { unitId, groupId, startDate } });
    } catch (err) {
        dispatch(showNotification(Notification.DANGER, 'Failed to assign unit to class'));
    }
};
